"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractService = void 0;
const ethers_1 = require("ethers");
class ContractService {
    constructor(provider, signer) {
        this.provider = provider;
        this.signer = signer;
    }
    async validateNetwork(expectedChainId) {
        const network = await this.provider.getNetwork();
        if (network.chainId !== BigInt(expectedChainId)) {
            throw new Error(`Chain ID mismatch. Expected ${expectedChainId}, got ${network.chainId}`);
        }
    }
    createContract(address, abi) {
        return new ethers_1.ethers.Contract(address, abi, this.signer);
    }
}
exports.ContractService = ContractService;
